/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SsoimageId200,
  GetApiV1SsoimageId401,
  GetApiV1SsoimageId404,
  GetApiV1SsoimageId500,
  GetApiV1SsoimageIdPathParams,
  GetApiV1SsoimageIdQueryResponse,
} from "../../types/SSOImageController/GetApiV1SsoimageId.ts";
import { SSOImageRepositoryResponseSchema } from "../SSOImageRepositoryResponseSchema.ts";

export const getApiV1SsoimageIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1SsoimageIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SsoimageId200Schema = z.lazy(
  () => SSOImageRepositoryResponseSchema,
) as unknown as ToZod<GetApiV1SsoimageId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SsoimageId401Schema =
  z.any() as unknown as ToZod<GetApiV1SsoimageId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SsoimageId404Schema =
  z.any() as unknown as ToZod<GetApiV1SsoimageId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SsoimageId500Schema =
  z.any() as unknown as ToZod<GetApiV1SsoimageId500>;

export const getApiV1SsoimageIdQueryResponseSchema = z.lazy(
  () => getApiV1SsoimageId200Schema,
) as unknown as ToZod<GetApiV1SsoimageIdQueryResponse>;
